<template>
    
    <div class="w-full">
        <slot name="header-content"></slot>
        <div class="flex center-xs space-top-1 w-full">
            <div class="flex vertical-center input-container w-full" >
                <slot name="body-content"></slot>
                <div v-for="(value, index) in step.valueList" :key="value" class="radio-wrapper">
                    <input type="radio" v-model="checkedValue" :value="value" :id="step.name + index" name="name" class="hidden">
                    <label class="radio-box" :for="step.name + index" tabindex="0">
                        <div class="mark-box flex start-xs">
                            <span class="radio-check-circle"></span>
                            <div class="radio-value">{{ value }}</div>
                        </div>
                    </label>
                </div>
                <div v-if="dipslayErrorMessage" class="red-text space-top-2">{{step.errorMessage}}</div>
            </div>
            
        </div>
        <slot name="disclaimer"></slot>
        <ButtonSection
            v-if="showButton"
            :inputValid="checkedValue !== ''"
            :order="order"
            :buttonText="step.buttonText"
            :exitButtonText="step.exitButtonText"
            :backButtonText="step.backButtonText"
            @progress="progress"
            @hide-modal="$emit('hide-modal')"
            @back="$emit('back')"
        />
        <slot name="login"></slot>
        
    </div>
</template>

<script>


import ButtonSection from './ButtonSection.vue';

export default {
    props: ['step', 'showButton'],
    components: {
        ButtonSection
    },
    data() {
      return {
          dirty: false,
          checkedValue: '',
      }
    },
    methods: {
        progress(){
            this.$emit('fleetSize', this.checkedValue)
            this.$emit('progress')
        }
    },

}
</script>

<style lang="scss" scoped>
.radio-value {
    display: inline-block;
    margin-left: 15px;
}

.mark-box {
    margin-top: 15px;
    position: relative;
}

.radio-check-circle {
    margin-top: 3px;
    height: 15px;
    width: 15px;
    color: #0384FB;
    background-color: #fff;
    border-radius: 50%;
    display: inline-block;

    &:after {
        width: 25px;
        height: 25px;
        content: "";
        border: 1px solid #BCBCBC;
        position: absolute;
        border-radius: 15px;
        display: block;
        left: -5px;
        top: -2px;
    }
}

.radio-wrapper {
    display: inline-block;
    position: relative;
    width: 100%;
}

label {
    background: #fcb608;
    padding: 2px 10px 2px 1.5em;
    border: 1px solid transparent; /* keeps layout from jumping */
}

input[type="radio"]:checked + label {
    border: 3px solid #0384FB;
    box-sizing: border-box;

    &>.mark-box>.radio-check-circle {
        margin-top: 3px;
        height: 15px;
        width: 15px;
        color: #0384FB;
        background-color: black;
        border-radius: 50%;
        display: inline-block;

        &:after {
            width: 25px;
            height: 25px;
            content: "";
            border: 1px solid #BCBCBC;
            position: absolute;
            border-radius: 15px;
            display: block;
            left: -5px;
            top: -2px;
        }
    }
}

.radio-box {
    margin: 5px 0;
    max-width: 588px;
    width: 100%;
    height: 60px;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #A7B2BE;
    border-radius: 4px;
}


</style>